import WorkLog from './WorkLog';

export default WorkLog;
